"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var srvPath = '/assets/surveys/2.0/js/survey.min.js';

var MopinionForm =
/*#__PURE__*/
function (_Component) {
  _inherits(MopinionForm, _Component);

  function MopinionForm(props) {
    var _this;

    _classCallCheck(this, MopinionForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MopinionForm).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "startTimer", function () {
      _this.waitTimer = setInterval(function () {
        if (_this.mopinionIsLoaded()) {
          _this.initializeForm();
        }
      }, 200);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearTimer", function () {
      if (_this.waitTimer !== null) {
        clearInterval(_this.waitTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "injectScript", function () {
      _this.startTimer();

      if (_this.isMopinionLibInjected() || document.getElementById('mopinion-survey-script')) return;
      var script = document.createElement("script");
      script.id = 'mopinion-survey-script';
      script.src = "https://".concat(_this.props.domain).concat(!_this.props.path ? srvPath : _this.props.path);
      script.async = 1;
      script.defer = 1;
      document.getElementsByTagName("head")[0].appendChild(script);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isMopinionLibInjected", function () {
      if (!document.scripts || document.scripts.length === 0) {
        return false;
      }

      var scripts = Object.assign([], document.scripts);
      return scripts.some(function (script) {
        return script.src.indexOf('mopinion') > -1 && script.src.indexOf('survey.min.js') > -1;
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mopinionIsLoaded", function () {
      return typeof window.srv !== "undefined";
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initializeForm", function () {
      var _this$props = _this.props,
          formKey = _this$props.formKey,
          domain = _this$props.domain,
          showButton = _this$props.showButton,
          forceOpen = _this$props.forceOpen;

      if (_this.renderDiv) {
        _this.clearTimer();

        var options = {
          key: formKey,
          domain: domain,
          divName: _this.renderDiv.id,
          trigger_method: showButton ? "passive" : "proactive"
        };

        if (typeof forceOpen !== "undefined") {
          options.openForm = true;
        }

        try {
          window.srv.open(options);
        } catch (e) {}
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmit", function (e) {
      if (e.detail && e.detail.key === _this.props.formKey) {
        _this.props.onSubmit(e.detail);
      }
    });

    _this.state = {};
    _this.renderDiv = null;
    _this.waitTimer = null;
    return _this;
  }

  _createClass(MopinionForm, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mopinionIsLoaded()) {
        this.initializeForm();
      } else {
        this.injectScript();
      }

      document.addEventListener('mopinion_feedback_sent', this.handleSubmit);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();

      try {
        window.srv.clearForm(this.props.formKey);
      } catch (e) {}

      document.removeEventListener('mopinion_feedback_sent', this.handleSubmit);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var formKey = this.props.formKey;
      return _react.default.createElement("div", {
        ref: function ref(node) {
          return _this2.renderDiv = node;
        },
        id: "mopinion--".concat(formKey)
      });
    }
  }]);

  return MopinionForm;
}(_react.Component);

exports.default = MopinionForm;

_defineProperty(MopinionForm, "defaultProps", {
  domain: 'app.mopinion.com',
  showButton: true,
  onSubmit: function onSubmit() {}
});

MopinionForm.propTypes = {
  formKey: _propTypes.default.string.isRequired,
  domain: _propTypes.default.string,
  showButton: _propTypes.default.bool,
  forceOpen: _propTypes.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mopinion-forms/dist/index.js
// module id = 1305
// module chunks = 0